import request from '../../shared/request'

export function getTemplatesList(template_type) {
  return request(`/templates/${template_type}`)
}

export function createTemplate(payload) {
  return request(`/templates/${payload.template_type}`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createTemplateWithAttachment(payload) {
  return request(`/templates/form/attachment`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function saveTemplateWithAttachment(payload) {
  return request(`/templates/form/attachment/${payload.templateId}`, {
    method: 'PUT',
    body: payload.formData,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function saveTemplate(payload) {
  return request(`/templates/${payload.template_type}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteTemplate(payload) {
  return request(`/templates/${payload.templateType}/id/${payload.templateId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getTemplateById(payload) {
  return request(`/templates/${payload.templateType}/id/${payload.templateId}`)
}

export function getWorkOrderTemplatesList() {
  return request('/templates/work_order')
}

export function getWorkOrderTemplatesItems(work_order_id) {
  return request(`/templates/work_order/${work_order_id}/item`)
}

export function getJobMinuteTemplates() {
  return request('/templates/job_minute')
}

export function getDriverRequestTemplates() {
  return request('/templates/driver_request')
}

export function getMaterialRequestTemplatesList() {
  return request('/templates/material_request')
}

export function getMaterialRequestTemplatesItems(material_request_id) {
  return request(`/templates/material_request/${material_request_id}/item`)
}

export function getServiceOrderTemplatesList() {
  return request('/templates/service_order')
}

export function getServiceOrderTemplatesItems(service_order_id) {
  return request(`/templates/service_order/${service_order_id}/item`)
}



// WEBPACK FOOTER //
// ./src/redux/api/template.js